var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAppstore(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_1841",
    "data-name": "Group 1841",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 207.1,
    height: 69.228,
    viewBox: "0 0 207.1 69.228",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1031",
    "data-name": "Rectangle 1031",
    width: 207.1,
    height: 69.227,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1840",
    "data-name": "Group 1840",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46",
    "data-name": "Path 46",
    d: "M190.609,0H16.5c-.635,0-1.262,0-1.9,0-.53,0-1.056.014-1.59.022a23.077,23.077,0,0,0-3.468.3,11.631,11.631,0,0,0-3.29,1.085,11.161,11.161,0,0,0-2.8,2.04A10.852,10.852,0,0,0,1.419,6.262,11.413,11.413,0,0,0,.337,9.555,22.382,22.382,0,0,0,.026,13.02C.01,13.551.009,14.084,0,14.614v40c.009.537.01,1.057.026,1.594a22.344,22.344,0,0,0,.312,3.465,11.365,11.365,0,0,0,1.082,3.3,10.723,10.723,0,0,0,2.039,2.793,10.873,10.873,0,0,0,2.8,2.04A11.645,11.645,0,0,0,9.548,68.9a23.538,23.538,0,0,0,3.468.3c.535.012,1.061.019,1.59.019.633,0,1.26,0,1.9,0H190.609c.621,0,1.255,0,1.876,0,.528,0,1.068-.007,1.6-.019a22.966,22.966,0,0,0,3.461-.3,11.815,11.815,0,0,0,3.3-1.092,10.835,10.835,0,0,0,2.8-2.04,11.113,11.113,0,0,0,2.046-2.793,11.414,11.414,0,0,0,1.071-3.3,23.239,23.239,0,0,0,.322-3.465c.005-.537.005-1.057.005-1.594.014-.63.014-1.255.014-1.893V16.5c0-.633,0-1.262-.014-1.89,0-.53,0-1.063-.005-1.594a23.261,23.261,0,0,0-.322-3.465,11.446,11.446,0,0,0-1.071-3.293,11.189,11.189,0,0,0-4.844-4.846,11.746,11.746,0,0,0-3.3-1.085,22.525,22.525,0,0,0-3.461-.3c-.528-.009-1.068-.019-1.6-.022C191.864,0,191.23,0,190.609,0Z",
    transform: "translate(0 0)",
    fill: "#a6a6a6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47",
    "data-name": "Path 47",
    d: "M13.978,67.074c-.528,0-1.042-.007-1.565-.019a21.766,21.766,0,0,1-3.235-.282,10.159,10.159,0,0,1-2.868-.948,9.344,9.344,0,0,1-2.418-1.758,9.238,9.238,0,0,1-1.767-2.418,9.963,9.963,0,0,1-.94-2.868A21.472,21.472,0,0,1,.9,55.535c-.012-.365-.026-1.58-.026-1.58V13.975s.016-1.2.026-1.547a21.607,21.607,0,0,1,.286-3.24,9.967,9.967,0,0,1,.941-2.876,9.277,9.277,0,0,1,1.757-2.42,9.659,9.659,0,0,1,2.426-1.77A10.112,10.112,0,0,1,9.172,1.18,21.924,21.924,0,0,1,12.417.9L13.979.875H191.838l1.58.022a21.324,21.324,0,0,1,3.217.28,10.3,10.3,0,0,1,2.89.948,9.674,9.674,0,0,1,4.18,4.188,10.01,10.01,0,0,1,.928,2.854,22.463,22.463,0,0,1,.3,3.266c.005.49.005,1.018.005,1.54.014.649.014,1.267.014,1.89V52.086c0,.628,0,1.243-.014,1.86,0,.562,0,1.078-.007,1.61a21.9,21.9,0,0,1-.294,3.207,9.987,9.987,0,0,1-.935,2.89,9.513,9.513,0,0,1-1.758,2.4,9.36,9.36,0,0,1-2.421,1.769,10.142,10.142,0,0,1-2.887.952,21.58,21.58,0,0,1-3.236.282c-.507.012-1.037.019-1.552.019l-1.876,0Z",
    transform: "translate(0.638 0.639)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48",
    "data-name": "Path 48",
    d: "M35.581,24.925a8.565,8.565,0,0,1,4.079-7.186A8.769,8.769,0,0,0,32.751,14c-2.906-.3-5.723,1.739-7.2,1.739-1.511,0-3.79-1.708-6.246-1.658a9.2,9.2,0,0,0-7.741,4.721c-3.347,5.794-.85,14.311,2.355,19,1.6,2.293,3.479,4.856,5.933,4.765,2.4-.1,3.3-1.53,6.194-1.53,2.871,0,3.712,1.53,6.215,1.473,2.577-.042,4.2-2.3,5.748-4.619a18.976,18.976,0,0,0,2.627-5.353,8.277,8.277,0,0,1-5.052-7.613",
    transform: "translate(7.286 10.21)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49",
    "data-name": "Path 49",
    d: "M24.409,14.762a8.435,8.435,0,0,0,1.93-6.042,8.584,8.584,0,0,0-5.552,2.873,8.025,8.025,0,0,0-1.98,5.817,7.093,7.093,0,0,0,5.6-2.648",
    transform: "translate(13.73 6.371)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50",
    "data-name": "Path 50",
    d: "M48.056,33.761H39.865L37.9,39.57h-3.47l7.76-21.492h3.605L53.551,39.57H50.022Zm-7.343-2.681h6.494L44,21.654h-.088Z",
    transform: "translate(25.155 13.209)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51",
    "data-name": "Path 51",
    d: "M61.391,29.348c0,4.868-2.608,8-6.539,8A5.313,5.313,0,0,1,49.92,34.6h-.074v7.76H46.632V21.514h3.114V24.12H49.8a5.554,5.554,0,0,1,4.988-2.771c3.975,0,6.6,3.143,6.6,8m-3.306,0c0-3.172-1.641-5.258-4.143-5.258-2.458,0-4.11,2.129-4.11,5.258,0,3.157,1.653,5.272,4.11,5.272,2.5,0,4.143-2.07,4.143-5.272",
    transform: "translate(34.073 15.597)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52",
    "data-name": "Path 52",
    d: "M71.355,29.348c0,4.868-2.606,8-6.539,8A5.312,5.312,0,0,1,59.886,34.6h-.074v7.76H56.6V21.514H59.71V24.12h.059a5.558,5.558,0,0,1,4.99-2.771c3.977,0,6.6,3.143,6.6,8m-3.306,0c0-3.172-1.639-5.258-4.142-5.258-2.458,0-4.11,2.129-4.11,5.258,0,3.157,1.653,5.272,4.11,5.272C66.411,34.62,68.05,32.55,68.05,29.348Z",
    transform: "translate(41.354 15.597)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53",
    "data-name": "Path 53",
    d: "M73.1,33.733c.237,2.13,2.309,3.531,5.137,3.531,2.71,0,4.661-1.4,4.661-3.321,0-1.668-1.177-2.667-3.962-3.351l-2.783-.672c-3.949-.954-5.78-2.8-5.78-5.794,0-3.707,3.233-6.255,7.819-6.255,4.541,0,7.655,2.548,7.76,6.255H82.706c-.2-2.144-1.968-3.439-4.557-3.439S73.783,22,73.783,23.9c0,1.52,1.134,2.414,3.9,3.1l2.369.582C84.463,28.625,86.3,30.4,86.3,33.541c0,4.02-3.205,6.539-8.3,6.539-4.766,0-7.984-2.459-8.19-6.346Z",
    transform: "translate(51.008 13.058)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54",
    "data-name": "Path 54",
    d: "M85.672,19.3v3.709h2.98v2.546h-2.98v8.638c0,1.343.6,1.968,1.907,1.968a9.841,9.841,0,0,0,1.057-.074v2.532a8.829,8.829,0,0,1-1.786.149c-3.172,0-4.41-1.191-4.41-4.23V25.555H80.162V23.009h2.279V19.3Z",
    transform: "translate(58.573 14.102)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55",
    "data-name": "Path 55",
    d: "M86.065,29.36c0-4.931,2.9-8.029,7.432-8.029s7.433,3.1,7.433,8.029-2.876,8.029-7.433,8.029S86.065,34.3,86.065,29.36m11.587,0c0-3.382-1.551-5.377-4.155-5.377s-4.155,2.011-4.155,5.377c0,3.4,1.549,5.376,4.155,5.376S97.652,32.755,97.652,29.36Z",
    transform: "translate(62.886 15.586)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_56",
    "data-name": "Path 56",
    d: "M96.186,21.514h3.067v2.667h.074a3.74,3.74,0,0,1,3.769-2.831,5.028,5.028,0,0,1,1.1.121v3.008a4.444,4.444,0,0,0-1.445-.194,3.24,3.24,0,0,0-3.37,3.107,3.428,3.428,0,0,0,.017.5v9.294H96.186Z",
    transform: "translate(70.281 15.597)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57",
    "data-name": "Path 57",
    d: "M115.352,32.591c-.433,2.845-3.2,4.8-6.746,4.8-4.559,0-7.388-3.055-7.388-7.954,0-4.915,2.845-8.1,7.253-8.1,4.335,0,7.061,2.979,7.061,7.729v1.1H104.464v.194a4.082,4.082,0,0,0,3.705,4.425,4.181,4.181,0,0,0,.511.014,3.548,3.548,0,0,0,3.619-2.2Zm-10.872-4.676h7.833a3.768,3.768,0,0,0-3.553-3.972c-.1-.005-.192-.007-.289-.005a3.969,3.969,0,0,0-3.991,3.943v.035",
    transform: "translate(73.958 15.586)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_58",
    "data-name": "Path 58",
    d: "M39.4,8.736a4.567,4.567,0,0,1,4.882,4.23,4.487,4.487,0,0,1-.024.9c0,3.3-1.783,5.2-4.858,5.2H35.671V8.736ZM37.275,17.6h1.947a3.245,3.245,0,0,0,3.434-3.048,3.185,3.185,0,0,0-.028-.666,3.259,3.259,0,0,0-3.406-3.693H37.275Z",
    transform: "translate(26.064 6.374)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_59",
    "data-name": "Path 59",
    d: "M41.688,14.151a3.692,3.692,0,1,1,7.35,0,3.693,3.693,0,0,1-7.35.717,3.812,3.812,0,0,1,0-.717m5.768,0c0-1.689-.758-2.677-2.091-2.677s-2.089.988-2.089,2.677.753,2.683,2.089,2.683S47.457,15.848,47.457,14.151Z",
    transform: "translate(30.448 7.385)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_60",
    "data-name": "Path 60",
    d: "M55.23,17.988h-1.6l-1.611-5.739H51.9l-1.6,5.739h-1.58l-2.148-7.793h1.559l1.4,5.947h.116l1.6-5.947h1.476l1.6,5.947h.121l1.39-5.947h1.537Z",
    transform: "translate(34.027 7.449)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61",
    "data-name": "Path 61",
    d: "M53.854,10.262h1.478V11.5h.116a2.334,2.334,0,0,1,2.326-1.388,2.533,2.533,0,0,1,2.7,2.9v5.045H58.934V13.4c0-1.253-.545-1.874-1.682-1.874a1.786,1.786,0,0,0-1.869,1.7,1.807,1.807,0,0,0,.01.273v4.559H53.854Z",
    transform: "translate(39.35 7.382)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1030",
    "data-name": "Rectangle 1030",
    width: 1.539,
    height: 10.836,
    transform: "translate(102.273 14.602)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62",
    "data-name": "Path 62",
    d: "M61.225,14.151a3.693,3.693,0,0,1,7.352-.7,3.975,3.975,0,0,1,0,.7,3.693,3.693,0,0,1-7.352.715,3.8,3.8,0,0,1,0-.715m5.768,0c0-1.689-.758-2.677-2.091-2.677s-2.089.988-2.089,2.677.753,2.683,2.089,2.683,2.091-.986,2.091-2.683",
    transform: "translate(44.724 7.385)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_63",
    "data-name": "Path 63",
    d: "M66.4,15.849c0-1.4,1.045-2.212,2.9-2.326L71.41,13.4v-.672c0-.824-.543-1.289-1.6-1.289-.858,0-1.454.317-1.623.867H66.7c.158-1.34,1.417-2.2,3.184-2.2,1.954,0,3.056.973,3.056,2.62v5.324H71.461v-1.1h-.121A2.617,2.617,0,0,1,69,18.18a2.352,2.352,0,0,1-2.584-2.1c-.009-.078-.012-.156-.014-.234m5.01-.666v-.651l-1.9.121c-1.073.071-1.559.436-1.559,1.123,0,.7.609,1.109,1.445,1.109a1.837,1.837,0,0,0,2.013-1.642l.005-.061",
    transform: "translate(48.517 7.386)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64",
    "data-name": "Path 64",
    d: "M71.348,15.372c0-2.463,1.265-4.022,3.235-4.022a2.565,2.565,0,0,1,2.39,1.367h.114V8.437h1.539V19.271H77.153V18.041H77.03a2.706,2.706,0,0,1-2.447,1.36c-1.982,0-3.235-1.561-3.235-4.029m1.589,0c0,1.653.779,2.648,2.082,2.648s2.1-1.009,2.1-2.641-.81-2.648-2.1-2.648S72.937,13.733,72.937,15.372Z",
    transform: "translate(52.133 6.165)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65",
    "data-name": "Path 65",
    d: "M79.237,14.151a3.692,3.692,0,1,1,7.35,0,3.693,3.693,0,0,1-7.35.717,3.811,3.811,0,0,1,0-.717m5.768,0c0-1.689-.758-2.677-2.091-2.677s-2.089.988-2.089,2.677.753,2.683,2.089,2.683,2.091-.986,2.091-2.683",
    transform: "translate(57.885 7.385)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_66",
    "data-name": "Path 66",
    d: "M84.669,10.262h1.48V11.5h.116a2.333,2.333,0,0,1,2.326-1.388,2.533,2.533,0,0,1,2.7,2.9v5.045H89.75V13.4c0-1.253-.545-1.874-1.682-1.874a1.786,1.786,0,0,0-1.869,1.7,1.807,1.807,0,0,0,.009.273v4.559H84.669Z",
    transform: "translate(61.866 7.382)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67",
    "data-name": "Path 67",
    d: "M94.688,9.074V11.05h1.689v1.295H94.688v4.008c0,.815.336,1.173,1.1,1.173a5.135,5.135,0,0,0,.587-.036v1.282a5.237,5.237,0,0,1-.838.078c-1.71,0-2.392-.6-2.392-2.1v-4.4H91.91V11.05h1.237V9.074Z",
    transform: "translate(67.157 6.63)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_68",
    "data-name": "Path 68",
    d: "M95.7,8.437H97.23v4.294h.121a2.4,2.4,0,0,1,2.376-1.395,2.567,2.567,0,0,1,2.7,2.423,2.652,2.652,0,0,1-.019.483v5.031h-1.54V14.621c0-1.244-.58-1.876-1.667-1.876a1.822,1.822,0,0,0-1.963,1.667,1.681,1.681,0,0,0,0,.31v4.552H95.7Z",
    transform: "translate(69.93 6.165)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69",
    "data-name": "Path 69",
    d: "M107.721,15.947a3.163,3.163,0,0,1-3.377,2.255,3.541,3.541,0,0,1-3.633-3.446,3.375,3.375,0,0,1,.033-.576,3.59,3.59,0,0,1,3.593-4.072c2.169,0,3.477,1.481,3.477,3.929v.537h-5.5v.087a2.06,2.06,0,0,0,1.88,2.226c.066.005.13.007.2.007a1.87,1.87,0,0,0,1.855-.945Zm-5.41-2.511h3.936a1.88,1.88,0,0,0-1.736-2.015q-.091-.005-.182-.005a2,2,0,0,0-2.018,1.97Z",
    transform: "translate(73.587 7.386)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppstore);
export default __webpack_public_path__ + "static/media/appstore.2da175b3466897460d8d34382b5637ef.svg";
export { ForwardRef as ReactComponent };